export const Title = ($rootScope: any, $timeout: ng.ITimeoutService) => (<angular.IDirective>{
    link: (scope: any, elem: JQLite, attrs: any) => {
        let listener = (event, toState) => {
            $timeout(() => {
                var notificationLengthString = $rootScope.userNotifications.length > 0 ? '(' + $rootScope.userNotifications.length + ') ' : '';
                $rootScope.pageTitle = notificationLengthString +
                    ((
                        event.targetScope
                        && event.targetScope.$state
                        && event.targetScope.$state.$current
                        && event.targetScope.$state.$current.data
                        && event.targetScope.$state.$current.data.pageTitle
                    )
                        ? event.targetScope.$state.$current.data.pageTitle + ' | ArchiSMALL'
                        : 'ArchiSMALL');
            }, 500);
        };
        $rootScope.$on('$locationChangeSuccess', listener);
    }
});

Title.$inject = ['$rootScope', '$timeout'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/title/title.directive.ts